import React, { useState } from 'react';
import people from './data';
import { FaChevronLeft, FaChevronRight, FaQuoteRight } from 'react-icons/fa';
const Review = () => {
    const [readMore, setReadmore] = useState(false);
    const [index, setIndex] = useState(2);
    const { name, department, image, text, role, batch,video } = people[index];
    const checkNumber = (number) => {
        if (number > people.length - 1) {
            return 0;
        }
        if (number < 0) {
            return people.length - 1;
        }
        return number;
    };
    const nextPerson = () => {
        setIndex((index) => {
            let newIndex = index + 1;
            return checkNumber(newIndex);
        });
    };
    const prevPerson = () => {
        setIndex((index) => {
            let newIndex = index - 1;
            return checkNumber(newIndex);
        });
    };


    return (
        <article className='review'>
            <div className='img-container'>
                <img src={image} alt={name} className='person-img' />
                <span className='quote-icon'>
                    <FaQuoteRight />
                </span>
            </div>
            <h4 className='author'>{name}</h4>
            <p className='job'>Batch: {batch}</p>
            <p className='job'>{department}</p>
            <p className='job'>Current Role: {role}</p>
            {
                text === ''?<div></div>:<p className='info allText'>
                {readMore ? text : `${text.substring(0, 200)}...`}

                <button onClick={() => setReadmore(!readMore)}>
                    {readMore ? 'Show Less' : 'Read More'}
                </button>
            </p>
            }

            {
                video===''?<div></div> : <video src={video} width="100%" height="300" controls="controls"  />
            }
            <div className='button-container'>
                <button className='prev-btn' onClick={prevPerson}>
                    <FaChevronLeft />
                </button>
                <button className='next-btn' onClick={nextPerson}>
                    <FaChevronRight />
                </button>
            </div>

        </article>
    );
};

export default Review;